import { TextWrapper, Wrapper, TextWrapperSpan } from "../../../constants/common/StyledGlobalConstants";
import PropTypes from "prop-types";

const VehicleDetails = ({ vehicleName, esn, vin, newVin, registrationNumber, newVehicleData, isVin }) => {
  const renderDetail = (label, value) => (
    <TextWrapper marginBottom="0.5rem">
      <TextWrapperSpan>{label}: </TextWrapperSpan>
      {value}
    </TextWrapper>
  );

  return (
    <Wrapper flex="1">
      <TextWrapper fontSize="1rem" fontWeight="700" lineHeight="1.375rem">
        {isVin ? (
          <>{newVehicleData ? "New vehicle details" : "Current vehicle details"}:</>
        ) : (
          <>{newVehicleData ? "New powered asset details" : "Current powered asset details"}:</>
        )}
      </TextWrapper>
      <Wrapper marginTop="1rem" fontWeight="400" lineHeight="0.875rem">
        {isVin ? (
          <>
            {newVehicleData ? (
              <>
                {renderDetail("Vehicle name", vehicleName)}
                {renderDetail("VIN", vin)}
              </>
            ) : (
              <>
                {renderDetail("Vehicle name", vehicleName)}
                {renderDetail("ESN", esn)}
                {renderDetail("VIN", vin || newVin)}
                {renderDetail("Registration number", registrationNumber)}
              </>
            )}
          </>
        ) : (
          <>
            {newVehicleData ? (
              <>{renderDetail("Asset name", vehicleName)}</>
            ) : (
              <>
                {renderDetail("Asset name", vehicleName)}
                {renderDetail("Asset number", registrationNumber)}
              </>
            )}
          </>
        )}
      </Wrapper>
    </Wrapper>
  );
};

VehicleDetails.propTypes = {
  vehicleName: PropTypes.string,
  esn: PropTypes.string,
  vin: PropTypes.string,
  newVin: PropTypes.string,
  registrationNumber: PropTypes.string,
  newVehicleData: PropTypes.bool,
  isVin: PropTypes.bool
};

export default VehicleDetails;